module.exports = __webpack_public_path__ + "img/2.ddd91321.jpg";